module.exports = __webpack_public_path__ + "img/searchresult_inactive.7b96ced4.svg";